import React, { useEffect, useState } from "react";
import { ShieldCheck, X } from "lucide-react";

import RepertoirePopulationPermissionsEditor from "./RepertoirePopulationPermissionsEditor";

const normalizePermission = (permission) => ({
    userId: Number(permission?.userId),
    canConsult: Boolean(permission?.canConsult || permission?.canCreate || permission?.canValidate),
    canCreate: Boolean(permission?.canCreate),
    canValidate: Boolean(permission?.canValidate),
});

function RepertoireUsersModal({
                                  open,
                                  onClose,
                                  repertoire,
                                  allUsers = [],
                                  allEntites = [],
                                  allJobs = [],
                                  onSave,
                              }) {
    const [filters, setFilters] = useState({
        filterMode: "IN",
        managerLevelFilter: "",
        entiteIds: [],
        posteIds: [],
        userIds: [],
    });
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        if (!open || !repertoire) return;

        setFilters({
            filterMode: repertoire.filterMode || "IN",
            managerLevelFilter: repertoire.managerLevelFilter || "",
            entiteIds: repertoire.entiteIds || [],
            posteIds: repertoire.posteIds || [],
            userIds: repertoire.userIds || [],
        });

        setPermissions(
            repertoire.userPermissions?.length > 0
                ? repertoire.userPermissions.map(normalizePermission)
                : (repertoire.authorizedUsers || []).map((user) =>
                    normalizePermission({
                        userId: user.id,
                        canConsult: true,
                        canCreate: false,
                        canValidate: false,
                    })
                )
        );
    }, [open, repertoire]);

    if (!open || !repertoire) return null;

    const handleSave = () => {
        const normalizedPermissions = (permissions || [])
            .filter((permission) => Number(permission.userId) > 0)
            .map(normalizePermission);

        onSave({
            ...filters,
            userPermissions: normalizedPermissions,
            authorizedUserIds: normalizedPermissions
                .filter(
                    (permission) =>
                        permission.canConsult || permission.canCreate || permission.canValidate
                )
                .map((permission) => Number(permission.userId)),
        });
    };

    return (
        <div className="rep-overlay" onMouseDown={onClose}>
            <div className="rep-modal rep-modal--wide" onMouseDown={(event) => event.stopPropagation()}>
                <div className="rep-modal__header">
                    <div className="rep-modal__title">
                        <ShieldCheck size={16} style={{ color: "#dc3545" }} />
                        Population cible et permissions - {repertoire.name}
                    </div>

                    <button type="button" className="rep-icon-btn" onClick={onClose}>
                        <X size={15} />
                    </button>
                </div>

                <div className="rep-modal__body">
                    <div className="rep-inline-meta">
                        <div className="rep-inline-meta__item">
                            <span className="rep-inline-meta__label">Répertoire</span>
                            <span className="rep-inline-meta__value">{repertoire.name}</span>
                        </div>
                    </div>

                    <RepertoirePopulationPermissionsEditor
                        allUsers={allUsers}
                        allEntites={allEntites}
                        allJobs={allJobs}
                        roleId=""
                        filters={filters}
                        permissions={permissions}
                        onChangeFilters={setFilters}
                        onChangePermissions={setPermissions}
                    />
                </div>

                <div className="rep-modal__footer">
                    <button type="button" className="rep-btn rep-btn--ghost" onClick={onClose}>
                        Annuler
                    </button>
                    <button type="button" className="rep-btn rep-btn--primary" onClick={handleSave}>
                        Enregistrer
                    </button>
                </div>
            </div>
        </div>
    );
}

export default RepertoireUsersModal;
